import { render, staticRenderFns } from "./ClassImport.vue?vue&type=template&id=09109972"
import script from "../../../controllers/custom/class/class-import.js?vue&type=script&lang=js&external"
export * from "../../../controllers/custom/class/class-import.js?vue&type=script&lang=js&external"
import style0 from "./ClassImport.vue?vue&type=style&index=0&id=09109972&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports